import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e45ef8e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }

import { reactive, watchEffect } from 'vue';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
        page: {
            type: Number,
            default: 1
        },
        pagesize: {
            type: Number,
            default: 10
        },
        pageSize: {
            type: Array,
            default: () => ([10, 20, 30, 50])
        },
        total: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
  emits: ['onPageChange'],
  setup(__props, { emit: emits }) {

const props = __props

    
    
    const pages = reactive({
        page: 1,
        pagesize: 10
    })

    watchEffect(() => {
        pages.page = props.page
        pages.pagesize = props.pagesize
    })


    const handleSizeChange = (val: number) => {
        emits('onPageChange', { page: pages.page, pagesize: val })
        console.log(`${val} items per page`)
    }
    const handleCurrentChange = (val: number) => {
        emits('onPageChange', { page: val, pagesize: pages.pagesize })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_pagination, {
      "current-page": pages.page,
      "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((pages.page) = $event)),
      "page-size": pages.pagesize,
      "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((pages.pagesize) = $event)),
      "page-sizes": __props.pageSize,
      disabled: __props.disabled,
      layout: "total, sizes, prev, pager, next, jumper",
      total: __props.total,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["current-page", "page-size", "page-sizes", "disabled", "total"])
  ]))
}
}

})